import React, { useContext, useEffect, useState } from 'react';
import CoreKnowledge from '../CoreKnowledge';
import CommunitySettings from '../CommunitySettings';
import Promotions from '../Promotions';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import LeadInfoOptions from '../LeadInfoOptions';
import AppointmentSchedule from '../AppointmentSchedule';
import LeadAISettings from '../LeadAISettings';

import LeadDetails from '../LeadDetails';
import AFMSettings from '../AFMSettings';
import { getCommunities } from '../../Redux/util/Apis/communities';
import KelseyInsight from '../../Container/KelseyInsight';
import LeadWaitList from '../LeadWaitList';
import Popup from '../../globalcomponents/Popup';
import { useInboxContext } from '../../utils/ContextProviders/InboxContextProvider';
import { GlobalContext } from '../../utils/ContextProviders/GlobalContextProvider';
import LeadInfoLoader from '../../globalcomponents/SkeletonLoaders/LeadInfoLoader';
import { useDispatch, useSelector } from 'react-redux';
import KelseyFeedback from '../KelseyFeedback';
import CommunityFees from '../CommunityFees';
import {
  getUnansweredLeadQueries,
  markLeadQueryAnswered
} from '../../Redux/util/Apis/leadMissedQueries';
import {
  setGlobalError,
  setSuccessInfo
} from '../../Redux/Reducer/GlobalError';
import { socketEmitter } from '../../utils/socket';

const LeadContainerInfo = props => {
  const dispatch = useDispatch();
  const { showAnnouncementsModal } = useInboxContext();
  const { darkMode, userData } = useContext(GlobalContext);
  const { inboxMetaData: inboxMetaSchedule } = useSelector(
    state => state.inboxMessages
  );

  const {
    setMessageInput,
    selectedLeadId,
    leadData,
    refetchLeadInfo,
    propertyData,
    handleAutofillData,
    isOnInboxPage,
    leadUpdateMutate,
    userId,
    setIsTabOpen,
    openSopDrawer,
    SOPDrawerToggleHandler,
    handlePNAExpansionToggle,
    isMaximizedPnAOpen
  } = props;

  const [selectedOption, setSelectedOptions] = useState('All');
  const [gettingLeadData, setGettingLeadData] = useState(true);

  const clientName = leadData?.tenant?.name;
  const tenantId = leadData?.tenant?._id;

  const { data: featureFlags } = useFeatureFlags(tenantId);
  const isPromotionsEnabled = featureFlags?.['promotions'] ?? false;

  const tenantName = leadData?.name;
  const apartmentId = leadData?.apartment?._id;

  const [unansweredLeadQueries, setUnansweredLeadQueries] = useState([]);

  const fetchUnansweredLeadQueries = async leadId => {
    if (!leadId) return;
    const queries = await getUnansweredLeadQueries(leadId);
    setUnansweredLeadQueries(queries);
  };

  useEffect(() => {
    if (leadData?._id) {
      fetchUnansweredLeadQueries(leadData._id);
    } else {
      setUnansweredLeadQueries([]);
    }
  }, [leadData?._id]);

  const queryAnsweredClickHandler = async (e, queryId) => {
    e.preventDefault();
    try {
      const updated = await markLeadQueryAnswered(selectedLeadId, queryId);
      if (updated) {
        dispatch(setSuccessInfo('Successfully marked question as answered!'));
      }
      socketEmitter('getLeadMessages', {
        leadId: selectedLeadId,
        user: userData
      });
      await fetchUnansweredLeadQueries(selectedLeadId);
    } catch (err) {
      dispatch(setGlobalError('Could not mark question as answered!'));
    }
  };

  const [apartmentData, setApartmentData] = useState([]);
  const [apartmentDataLoading, setApartmentDataLoading] = useState(false);
  useEffect(() => {
    if (!tenantId) return;
    setSelectedOptions('All');
    setApartmentDataLoading(true);
    let cancelled = false;
    getCommunities(tenantId)
      .then(res => {
        if (cancelled) return;
        const items = Array.isArray(res) ? res : res?.data || [];
        // Map REST snake_case back into the camelCase shape downstream
        // consumers (KelseyInsight, AppointmentSchedule, LeadDetails, ...)
        // already use, so the migration stays contained to this boundary.
        setApartmentData(
          items.map(c => ({
            _id: c.id,
            name: c.name,
            isLive: c.is_live,
            phone: c.phone,
            addressId: c.address?.id ?? null
          }))
        );
      })
      .finally(() => {
        if (!cancelled) setApartmentDataLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tenantId]);

  useEffect(() => {
    if (selectedOption === 'promotions' && !isPromotionsEnabled) {
      setSelectedOptions('All');
    }
  }, [isPromotionsEnabled, selectedOption]);

  useEffect(() => {
    setGettingLeadData(apartmentDataLoading);
  }, [apartmentDataLoading]);

  return (
    <div
      className={`leadContainerBox${darkMode ? '-dark' : ''}  ${
        isOnInboxPage ? '' : 'leadContainerBoxLead'
      }`}
      style={{
        position: showAnnouncementsModal ? 'relative' : '',
        overflow: showAnnouncementsModal && 'hidden'
      }}
    >
      {gettingLeadData ? (
        <LeadInfoLoader></LeadInfoLoader>
      ) : (
        <>
          {showAnnouncementsModal && (
            <Popup
              width="0px"
              overlayRadius={'6px'}
              overlayColor="rgba(0, 0, 0, 0.25)"
              overlayPosition="absolute"
            />
          )}
          <div className={!showAnnouncementsModal && 'position-sticky'}>
            <LeadInfoOptions
              {...{
                selectedOption,
                setSelectedOptions,
                isKelseyQueryListFilled: unansweredLeadQueries?.length > 0,
                isPromotionsEnabled
              }}
            />
          </div>
          {selectedOption === 'All' ? (
            <KelseyInsight
              {...{
                tenantName,
                clientName,
                userId,
                leadData,
                propertyData,
                apartments: apartmentData,
                leadUpdateMutate,
                handleAutofillData,
                setIsTabOpen,
                enableBot: leadData?.enableBot || false,
                aiBotSettings: inboxMetaSchedule?.ai,
                schedule: inboxMetaSchedule?.schedule,
                openSopDrawer,
                SOPDrawerToggleHandler,
                handlePNAExpansionToggle,
                isMaximizedPnAOpen
              }}
            />
          ) : null}
          {selectedOption == 'All' || selectedOption == 'unit' ? (
            <AppointmentSchedule
              leadData={leadData}
              selectedLeadId={selectedLeadId}
              apartmentData={apartmentData}
              propertyData={propertyData}
              inboxMetaSchedule={inboxMetaSchedule}
              selectedOption={selectedOption}
            />
          ) : null}
          {selectedOption == 'All' ? (
            <LeadAISettings
              {...{
                selectedLeadId,
                enableBot: leadData?.enableBot || false,
                aiData: inboxMetaSchedule?.ai,
                leadUpdateMutate,
                leadData
              }}
            />
          ) : null}
          {selectedOption == 'All' ? (
            <AFMSettings
              {...{
                selectedLeadId,
                followupToggle: leadData?.followupToggle || false,
                leadUpdateMutate
              }}
            />
          ) : null}
          {selectedOption == 'All' ? (
            <LeadWaitList
              {...{
                leadId: selectedLeadId,
                waitListExists: leadData?.waitlist ?? [],
                refetchLeadInfo
              }}
            />
          ) : null}
          {selectedOption == 'card' ? (
            <LeadDetails
              {...{
                selectedLeadId,
                leadData: leadData || {},
                phoneType: leadData?.meta?.phoneType || null,
                firstContactType: leadData?.meta?.firstContactType || null,
                apartmentData,
                propertyData,
                leadUpdateMutate,
                refetchLeadInfo
              }}
            />
          ) : null}
          {selectedOption == 'coreKnowledge' ? (
            <CoreKnowledge
              {...{
                setMessageInput,
                apartmentId,
                apartmentData,
                tenantId: tenantId
              }}
            />
          ) : null}
          {selectedOption == 'communitySettings' ? (
            <CommunitySettings
              {...{
                apartmentId
              }}
            />
          ) : null}
          {selectedOption == 'communitySettings' ? (
            <CommunityFees tenantId={tenantId} apartmentId={apartmentId} />
          ) : null}
          {selectedOption == 'promotions' ? (
            <Promotions
              {...{
                tenantId,
                apartmentId
              }}
            />
          ) : null}
          {selectedOption == 'kelseyFeedback' ? (
            <KelseyFeedback
              unansweredLeadQueries={unansweredLeadQueries}
              queryAnsweredClickHandler={queryAnsweredClickHandler}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default React.memo(LeadContainerInfo);
